import { WelcomeTexts } from '../../components/atomic/text/welcome_texts/WelcomeTexts';
import titleTextImg from './title_text.svg';
import descriptionTextImg from './description_text.svg';
import './Texts.css';

/** From welcome_screen_1.svg → title_text + description_text. */
export function Texts() {
  return (
    <WelcomeTexts
      titleSrc={titleTextImg}
      titleClassName="welcome-delivery-1-texts__title"
      descriptionSrc={descriptionTextImg}
      descriptionClassName="welcome-delivery-1-texts__description"
    />
  );
}
